import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";
import { NsExpWidget } from "../models/widgets.models";
@Injectable({
  providedIn: "root"
})
export class WidgetService {
  private refresh$ = new Subject<[NsExpWidget.TWidgetGroups, boolean] | undefined>();
  refresh = this.refresh$.asObservable();

  private widgetAction$ = new BehaviorSubject<string>(null);
  widgetAction = this.widgetAction$.asObservable();
  constructor() {}

  refreshWidgets(types?: NsExpWidget.TWidgetGroups, val?: boolean): void {
    setTimeout(() => this.refresh$.next([types, val]), 10);
  }

  setWidgetAction(action?: string) {
    this.widgetAction$.next(action);
  }
}
